<template>
  <teleport to="body">
    <div v-if="modelValue" class="pos-modal-backdrop" @click.self="close">
      <div class="pos-modal" role="dialog" aria-modal="true" :aria-label="title">
        <div class="pos-modal-header">
          <h6 class="mb-0">{{ title }}</h6>
          <button type="button" class="btn-close pos-tap" :aria-label="closeLabel" @click="close"></button>
        </div>
        <div class="pos-modal-body">
          <slot />
        </div>
        <div class="pos-modal-footer">
          <button type="button" class="btn btn-primary w-100 pos-tap" @click="close">{{ doneLabel }}</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: '' },
  doneLabel: { type: String, default: 'OK' },
  closeLabel: { type: String, default: 'Cerrar' }
})

const emit = defineEmits(['update:modelValue'])

const close = () => emit('update:modelValue', false)
</script>
